<template>
    <div class="calendar-container">
        <FullCalendar class="custom-calendar" :options="calendarOptions" />
    </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

export default {
    components: {
        FullCalendar,
    },
    props: {
        tasks: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            calendarOptions: {
                plugins: [dayGridPlugin, interactionPlugin],
                initialView: 'dayGridMonth',
                editable: false,
                selectable: true,
                selectMirror: true,
                dayMaxEvents: true,
                weekends: true,
                events: [
                    {
                        title: 'Read Chapter 1',
                        start: '2024-09-02',
                        end: '2024-09-04',
                        extendedProps: {
                            duration: '10 Days Planner - 03 Aug to 10 Sep',
                        },
                    },
                    {
                        title: 'Read Chapter 2',
                        start: '2024-09-05',
                        end: '2024-09-07',
                        extendedProps: {
                            duration:  '03 Days Planner - 03 Aug to 10 Sep',
                        },
                    },
                    {
                        title: 'Read Chapter 3',
                        start: '2024-09-10',
                        end: '2024-09-12',
                        extendedProps: {
                            duration:  '03 Days Planner - 03 Aug to 10 Sep',
                        },
                    },
                    {
                        title: 'Read Chapter 2',
                        start: '2024-09-25',
                        end: '2024-09-28',
                        extendedProps: {
                            duration:  '03 Days Planner - 03 Aug to 10 Sep',
                        },
                    },
                    {
                        title: 'Read Chapter 6',
                        start: '2024-09-15',
                        end: '2024-09-18',
                        extendedProps: {
                            duration:  '03 Days Planner - 03 Aug to 10 Sep',
                        },
                    },
                    {
                        title: 'Read Chapter 7',
                        start: '2024-09-29',
                        end: '2024-10-03',
                        extendedProps: {
                            duration:  '03 Days Planner - 03 Aug to 10 Sep',
                        },
                    }
                ], 
                eventContent: this.renderEventContent, 
            },
        };
    },
    computed: {
        mappedEvents() {
            return this.mapTasksToEvents(this.tasks);
        },
    },
    watch: {
        tasks: {
            handler(newTasks) {
                // this.calendarOptions.events = this.mapTasksToEvents(newTasks);
            },
            immediate: true,
        },
    },
    methods: {
        renderEventContent(arg) {
            return {
                html: `
            <div class="custom-event">
              <div class="event-title">${arg.event.title}</div>
              <div class="event-details">
                <span class="event-icon">⏰</span> ${arg.event.extendedProps.duration}
              </div>
            </div>
          `,
            };
        },
        formatDate(date) {
            const d = new Date(date);
            const year = d.getFullYear();
            const month = (d.getMonth() + 1).toString().padStart(2, '0');
            const day = d.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        mapTasksToEvents(tasks) {
            return tasks.map(task => {
                return {
                    title: task.title || 'No Title',
                    start: task.startDate ? this.formatDate(task.startDate) : '', 
                    end: task.endDate ? this.formatDate(task.endDate) : '',       
                    extendedProps: {
                        duration: this.formatDateRange(task.startDate, task.endDate)
                    }
                };
            });
        },
        formatDateRange(startDateStr, endDateStr) {
      const startDate = new Date(startDateStr);
      const endDate = new Date(endDateStr);

      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        return 'Invalid date';
      }

      return `10 Days Planner - ${this.formatDate(startDate)} to ${this.formatDate(endDate)}`;
    },

    formatDate(date) {
      if (!(date instanceof Date) || isNaN(date.getTime())) {
        return 'Invalid date';
      }

      const options = { day: '2-digit', month: 'short' };
      return new Intl.DateTimeFormat('en-GB', options).format(date);
    }
    },
};
</script>

<style>
.calendar-container .fc a {
    color: unset;
    text-decoration: none;
    font-size: medium;
}

.calendar-container .fc {
    height: 100%;
}

.calendar-container .fc-toolbar-title {
    color: black;
    font-size: large;
    font-weight: bold;
}

.calendar-container .fc .fc-col-header-cell-cushion {
    font-weight: bold;
    color: var(--primary-color);
    font-size: medium;
    padding: 20px 10px;
}

.calendar-container .fc-daygrid-event {
    background-color: white;
    color: black;
    padding: 5px;
    border-radius: 5px;
    border: 1px solid var(--primary-color);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
    margin: 5px;
}

.calendar-container .custom-event {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 5px;
}

.calendar-container .event-title {
    color: black;
    font-size: medium;
    margin-bottom: 10px;
}

.calendar-container .event-details {
    font-size: 12px;
    color: black;
    display: flex;
    align-items: center;
    justify-content: center;
}

.calendar-container .event-icon {
    margin-right: 5px;
}

.fc-daygrid-day-frame.fc-scrollgrid-sync-inner {
    background: white;
}

.calendar-container .fc-daygrid-day-number {
    margin: 6px 6px 0px 0px;
}

.calendar-container .fc-day-today .fc-daygrid-day-number {
    background: var(--primary-color);
    color: white;
    border-radius: 6px;
    padding: 5px;
}

.calendar-container .fc .fc-button {
    border: 0.8px solid var(--primary-color);
    background-color: transparent;
    color: black;
    padding: 5px 10px;
    border-radius: 10px;
    font-size: medium;
    font-weight: bold;
    text-transform: capitalize;
    transition: background-color 0.3s, color 0.3s;
}

.calendar-container .fc .fc-button:hover {
    background-color: var(--primary-color);
    color: white;
}

.calendar-container .fc .fc-button:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.2);
}</style>
